import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=bbe3f374"
import script from "./ShowMore.vue?vue&type=script&lang=js"
export * from "./ShowMore.vue?vue&type=script&lang=js"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=bbe3f374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports